import { StrategyBuilderFunction, EMPTY_STRATEGY } from './types';
import { addLongCall, addShortCall } from './addOption';
import {
  getDefaultExpiration,
  findClosestStrikePrice,
  getStrikesAtExpiration,
  expirationToDate,
  getPremium,
  getStrategyLegStrikeDirection,
  getStrikeDistance,
} from './utils';

export const longCallButterfly: StrategyBuilderFunction = ({
  chain,
  spot,
  expirationDate,
  expirationKey,
  strikeDirection,
  contractMultiplier = 1,
}) => {
  const strikesAtExpiration = expirationKey
    ? getStrikesAtExpiration(chain, expirationKey)
    : getDefaultExpiration(chain);

  if (
    !strikesAtExpiration ||
    !strikesAtExpiration.e ||
    !strikesAtExpiration.ey ||
    !strikesAtExpiration.em ||
    !strikesAtExpiration.ed
  ) {
    return EMPTY_STRATEGY;
  }

  const expirationDateForOptions =
    expirationDate ||
    expirationToDate(strikesAtExpiration.ey, strikesAtExpiration.em, strikesAtExpiration.ed);
  const expirationKeyForOptions = expirationKey || strikesAtExpiration.e;

  // Define strike prices
  const lowerStrike = findClosestStrikePrice(
    strikesAtExpiration,
    getStrikeDistance({ price: spot, unit: -2 }),
  ); // Buying 1 ITM call
  const middleStrike = findClosestStrikePrice(strikesAtExpiration, spot); // Selling 2 ATM calls
  const higherStrike = findClosestStrikePrice(
    strikesAtExpiration,
    getStrikeDistance({ price: spot, unit: 2 }),
  ); // Buying 1 OTM call

  return {
    optionPositions: [
      // Buy 1 ITM call option
      addLongCall({
        strike: lowerStrike,
        premium: getPremium({
          ask: strikesAtExpiration?.c?.[lowerStrike]?.c?.a || 0,
          bid: strikesAtExpiration?.c?.[lowerStrike]?.c?.b || 0,
          strikeDirection: getStrategyLegStrikeDirection(strikeDirection, 'long'),
        }),
        expirationDate: expirationDateForOptions,
        expirationKey: expirationKeyForOptions,
        numberOfContracts: 1 * contractMultiplier,
      }),
      // Sell 2 ATM call options
      addShortCall({
        strike: middleStrike,
        premium: getPremium({
          ask: strikesAtExpiration?.c?.[middleStrike]?.c?.a || 0,
          bid: strikesAtExpiration?.c?.[middleStrike]?.c?.b || 0,
          strikeDirection: getStrategyLegStrikeDirection(strikeDirection, 'short'),
        }),
        expirationDate: expirationDateForOptions,
        expirationKey: expirationKeyForOptions,
        numberOfContracts: 2 * contractMultiplier,
      }),
      // Buy 1 OTM call option
      addLongCall({
        strike: higherStrike,
        premium: getPremium({
          ask: strikesAtExpiration?.c?.[higherStrike]?.c?.a || 0,
          bid: strikesAtExpiration?.c?.[higherStrike]?.c?.b || 0,
          strikeDirection: getStrategyLegStrikeDirection(strikeDirection, 'long'),
        }),
        expirationDate: expirationDateForOptions,
        expirationKey: expirationKeyForOptions,
        numberOfContracts: 1 * contractMultiplier,
      }),
    ],
    stockPositions: [],
  };
};
